import axios from 'axios'
import {LoginResponse} from '../types/hooks/auth'

const { REACT_APP_MASTERDATAS_API_URL } = process.env

export interface Supplierclass {
    id: string
    sup_class_id: string
    sup_class_name: string
  
  
 
}

const handleResponseError = (error: any) => {
    //? = protect data no value
    if(error?.response?.data?.error){
        throw error.response.data.error
    }
    throw error
}

export const requestSupplierclasses = async(conditions: object = {},accessToken: string): Promise<Supplierclass[]> => {
    const data:Supplierclass[] = await axios
    .get(`${REACT_APP_MASTERDATAS_API_URL}/supplierclasses/all?access_token=${accessToken}`,{
        // headers: {
        //     Authorization: `Bearer ${accessToken}`
        // }
    })
    .then(response => response.data)
    .catch(error => handleResponseError(error))

    return data
}

